import type { ColorPalette, ExtendedColorValue } from '@acceligentllc/shared/enums/color';
import { DefaultColor } from '@acceligentllc/shared/enums/color';

import { DEFAULT_INTERNAL_CREW_TYPE_NAME, UNDEFINED_CREW_TYPE_NAME } from 'ab-common/constants/crewType';

export default class BasicCrewType {
	name: string;
	/**
	 * Has only `ColorPalette` values in a regular scenario (i.e. when saved in the DB),
	 * but can have `AdditionalColors` values when used on a linked model, such as `WorkOrder`
	 */
	color: Nullable<ExtendedColorValue>;
	foremanEnabled: boolean;

	constructor(name: Nullable<string>, color: Nullable<ColorPalette>, foremanEnabled: boolean) {
		this.name = name ?? BasicCrewType.UNDEFINED.name;
		this.color = color ?? BasicCrewType.UNDEFINED.color;
		this.foremanEnabled = foremanEnabled;
	}

	// eslint-disable-next-line @typescript-eslint/member-ordering
	static UNDEFINED: BasicCrewType = {
		name: UNDEFINED_CREW_TYPE_NAME,
		color: null,
		foremanEnabled: false,
	};

	/**
	 * Used for crew types of internal jobs
	 * @param crewTypeName usually `WorkOrder.customCrewType`
	 */
	static internal(crewTypeName: Nullable<string>, foremanEnabled?: boolean): BasicCrewType {
		return {
			name: crewTypeName ?? DEFAULT_INTERNAL_CREW_TYPE_NAME,
			color: DefaultColor.INTERNAL_JOB,
			foremanEnabled: foremanEnabled ?? false,
		};
	}
}
